import {Stack, Box, Text} from "@chakra-ui/react";
import React, { useCallback } from "react";
import {useUser} from "@/contexts/userContext";
import {useLanguage} from "@/contexts/languageContext";

export const UserPreview = (props) => {
    const {user, role, isAdmin} = useUser();
    const { t } = useLanguage();

    const getRole = useCallback((isAdmin, role) => {
        if(isAdmin){
            return t('roles.admin');
        }
        switch (role){
            default:
            case 'PLAYER':
                return t('roles.player');
        }
    },[]);

    const getFullnameOrEmail = useCallback((user) => {
        if(user?.firstname && user?.lastname){
            return `${user?.firstname} ${(user?.lastname ?? '').toUpperCase()}`;
        }
        return user?.email;
    }, [])

    return <Stack direction="row" alignItems="center" {...props}>
        {/* <Box borderRadius="50%" h="3rem" w="3rem" bg="primary.300"/> */}
        <Stack direction="column" gap={0} alignItems="flex-start" justifyContent="center">
            <Text color={'white'} fontWeight="bold">{ getFullnameOrEmail(user?.user ?? {}) }</Text>
            <Text fontSize="sm" color="primary.500">{ getRole(isAdmin, role) }</Text>
        </Stack>
    </Stack>
};

export default UserPreview;
